import React from 'react';
import { ShowIf } from 'components/utils';
import {msg} from "constants/message";
import {validatable} from 'components/utils';

class DropDown extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.selectedValue,
      isValid: true
    }
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  onChange(e) {
    this.state.value = e.target.value;
    this.setState({ ...this.state });
    this.props.onChange(e);
  }

  validate() {
    if (!this.state.value && this.props.require) {
      this.setState({
        isValid: false
      });
      this.select.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  componentWillReceiveProps(nextProps) {

    this.setState({
      value: nextProps.selectedValue
    });

    // if (nextProps.confirm) {
    //   this.setState({
    //     value: nextProps.selectedValue
    //   });
    // }
  }

  classNames() {
    if (!this.state.isValid && !this.state.value) {
      return 'pt-intent-danger';
    } else {
      return '';
    }
  }

  focus() {
    this.select.focus();
  }

  render() {
  return (
      <div className={this.props.className + ' mb18'}>
        <ShowIf condition={this.props.label != ''}>
          <label className="ip-label">
            { this.props.label }
            <ShowIf condition={this.props.require == true}>
              <span className="text-required">&nbsp;*</span>
            </ShowIf>
          </label>
          </ShowIf>
        <div className='pt-select'>
          <select disabled={this.props.disabled} className={ this.classNames() } value={ this.state.value } onChange={ this.onChange.bind(this) } ref={(select) => {this.select = select}} name = {this.props.name}>
            { this.props.placeholder != null ?
              <option value=''>
                --Chọn--
              </option>
              : '' }
            { this.props.options.map((item, i) => {
                return (<option key={i} value={ item[this.props.keyName] }>
                          { item[this.props.valueName] }
                        </option>);
              }) }
          </select>
        </div>
        <ShowIf condition={!this.state.isValid && !this.state.value}>
          <div className="pt-form-helper-text">{msg.messageDefault}</div>
        </ShowIf>
      </div>
      );
  }
}

DropDown.defaultProps = {
  className: 'input-group',
  disabled: false,
  label: '',
  options: [],
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  onRef: function() {
  },
  selectedValue: '',
  keyName: 'key',
  valueName: 'value',
  placeholder: null,
  require: false,
  name : '',
}

export default validatable(DropDown);



// WEBPACK FOOTER //
// ./src/components/tt-forms/common/DropDown.jsx